import angular from "angular";
import invite from "../invite";
import core from "../../core/core.module";
import capitalizeFirst from "../../capitalize-first/capitalize-first.module";

let mod =angular
    .module('invitesControl.inviteForm', [invite, core, capitalizeFirst])
    .component('inviteForm', {
        controller: ['Invite', 'notifier', 'Data', controller],
        template: require('./invite-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Invite, notifier, Data) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.agregator = $ctrl.resolve.agregator;

        $ctrl.type = null;
        $ctrl.organization = null;
        $ctrl.lastName = null;
        $ctrl.firstName = null;
        $ctrl.email = null;
        $ctrl.phone = null;
        $ctrl.position = null;

        if ($ctrl.resolve.inputInvite) {
            setInputInvite($ctrl.resolve.inputInvite);
        }
    };

    function setInputInvite(invite) {
        $ctrl.type = invite.type;
        $ctrl.organization = invite.organization;
    }

    $ctrl.getOrganizations = function (fragment) {
        return Data.getOrganizations(fragment);
    };

    $ctrl.typeChanged = function () {
        $ctrl.organization = null;
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let org = $ctrl.type == 'owner' ? $ctrl.agregator : $ctrl.organization;

        let params = {
            type: $ctrl.type,
            organization_id: org.id,
            last_name: $ctrl.lastName,
            first_name: $ctrl.firstName,
            email: $ctrl.email,
            phone: $ctrl.phone,
            position: $ctrl.position
        };

        Invite.create(params).then(
            function (response) {
                $ctrl.loading = false;
                notifier.successNotify('Приглашение успешно отправлено');
                params.id = response.data.id;
                params.expire_at = response.data.expire_at;
                params.organization = org;
                params.added_on = new Date();
                params.status = 'active';
                $ctrl.close({$value: params});
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/invites-control/invite-form/invite-form.js